<template>
  <div style="padding:0 50px">
    <template v-if="actionType === 1">
      <div>
        <div style="display:flex;align-items:center;">
          <span>角色名称</span>
          <el-input
            v-model="roleName"
            style="width:75%;margin-left:20px"
          ></el-input>
        </div>
        <div style="margin:30px 0 0 0">
          <span>
            角色名称不可与其他角色相同，后续如果想删除角色，需确保该角色下没有关联对应的子账号。最长10个汉字。
          </span>
        </div>
      </div>
    </template>
    <template v-if="actionType === 2">
      <div>
        <div style="display:flex;align-items:center;">
          <span>原角色名称</span>
          <el-input
            :value="oldRoleName"
            :disabled="true"
            style="width:75%;margin-left:20px"
          ></el-input>
        </div>
        <div style="display:flex;align-items:center;margin-top:20px">
          <span>新角色名称</span>
          <el-input
            v-model="roleName"
            style="width:75%;margin-left:20px"
          ></el-input>
        </div>
        <div style="margin:30px 0 0 0">
          <span>
            新角色名称不可与其他角色名称重名。最长10个汉字。
          </span>
        </div>
      </div>
    </template>
    <template v-if="actionType === 3">
      <div>
        <div style="margin:30px 0 0 0">
          <div>
            {{ customText }}
            <div v-html="customHTML"></div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    actionType: {
      type: Number,
      require: true
    },
    oldRoleName: {
      type: String,
      require: false
    },
    customText: {
      type: String,
      require: false
    },
    customHTML: {
      type: String,
      require: false
    }
  },
  data() {
    return {
      roleName: ''
    };
  },
  watch: {
    roleName: function(value) {
      if (value.length > 10) {
        this.roleName = this.roleName.slice(0, 10);
      }
    }
  }
};
</script>

<style></style>
